import { Flower2 } from "lucide-react";

export const Marquee = ({ items }) => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="marquee-paused overflow-hidden border-y border-gold/20 bg-blush/30 py-5" data-testid="marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-serif text-xl sm:text-2xl italic font-medium text-rosedeep/80">
                  {item}
                </span>
                <Flower2 className="w-4 h-4 text-gold/70" strokeWidth={1.5} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
